<template>

  <div class="orders-create" style="display:hidden">
        <form @submit.prevent="submit">

          <div class="card form">

            <header class="card-header has-background-dark is-size-4">
              <p class="card-header-title has-text-light">BASIC CREATE</p>
            </header>

            <div class="card-content scrollable is-relative">
              <!-- Order ID Field -->
              <!-- <div class="field is-horizontal">
                <div class="field-label">
                  <label class="label">Order ID</label>
                </div>
                <div class="field-body">
                  <b-field>
                    <b-input name="order_id" v-model="form.orderId" size="is-small"></b-input>
                  </b-field>
                </div>
              </div> -->

              <!-- Issued By Fields -->
              <div class="field is-horizontal">
                <div class="field-label">
                  <label class="label">Issued By</label>
                </div>
                <div class="field-body">
                  <b-field>
                    <base-select
                      name="issued_by"
                      ref="issuedBy"
                      :fetch-on-init="false"
                      :service="firmService"
                      fetch-func="parents"
                      :fetch-params="{ permissions: ['can issue orders'] }"
                      value-key="id"
                      label-key="name"
                      label
                      :small="true"
                      :value.sync="form.issuingOrganization"
                    ></base-select>
                  </b-field>
                </div>
              </div>


              <!-- <div class="field is-horizontal" v-if="hasSpendLimit">
                <div class="field-label">
                  <label class="label">Approver
                  </label>
                </div>
                <div class="field-body">
                  <b-field>

                    <b-select placeholder="Select a approver" size="is-small" v-model="form.approver" expanded>
                    </b-select>

                  </b-field>
                </div>
              </div> -->


              <div class="field is-horizontal">
                <div class="field-label">
                  <label class="label">Select Asset</label>
                </div>
                <div class="field-body">
                  <b-field>
                    <b-autocomplete
                      :data="assets"
                      field="tags"
                      size="is-small"
                      placeholder="Search by Asset Details"
                      icon="magnify"
                      clearable
                      @select="option => assetId = option.id">
                      <template slot="empty">No results found</template>
                  </b-autocomplete>
                  </b-field>
                </div>
              </div>

              <!-- Manage By Fields -->
              <div class="field is-horizontal">
                <div class="field-label">
                  <label class="label">Managed By</label>
                </div>
                <div class="field-body">

                  <b-field >
                      <b-select
                      size="is-small"
                      :disabled="!form.issuingOrganization"
                      v-model="form.manager"
                      expanded>
                          <option value="">Please Select</option>
                          <option
                              v-for="option in manager"
                              :value="option.id"
                              :key="option.id">
                              {{ option.fullName }}
                          </option>
                      </b-select>
                  </b-field>

                </div>
              </div>

              <div class="field is-horizontal">
                <div class="field-label">
                  <label class="label">Requested By</label>
                </div>
                <div class="field-body">
                  <b-field>
                    <base-select
                      name="requested_by"
                      ref="requestedBy"
                      label
                      :service="firmService"
                      fetch-func="children"
                      :fetch-params="{ firm_firm_permissions: ['can be issued orders'] }"
                      value-key="id"
                      label-key="name"
                      :small="true"
                      :value.sync="form.requested_by"
                    ></base-select>
                  </b-field>
                </div>
              </div>


              <div class="field is-horizontal">
                <div class="field-label">
                  <label class="label">Contact Person</label>
                </div>
                <div class="field-body">
                  <b-field >
                      <b-select
                      size="is-small"
                      :disabled="!form.issuingOrganization"
                      v-model="form.contact_person"
                      expanded>
                          <option value="">Please Select</option>
                          <option
                              v-for="option in manager"
                              :value="option.id"
                              :key="option.id">
                              {{ option.fullName }}
                          </option>
                      </b-select>
                  </b-field>
                </div>
              </div>


              <div class="field is-horizontal">
                <div class="field-label">
                  <label class="label">Issued To</label>
                </div>
                <div class="field-body">
                  <b-field>
                    <base-select
                      name="issued_to"
                      ref="issuedTo"
                      label
                      :service="firmService"
                      fetch-func="children"
                      :fetch-params="{ firm_firm_permissions: ['can be issued orders'] }"
                      value-key="id"
                      label-key="name"
                      :small="true"
                      :value.sync="form.contractor"
                    ></base-select>
                  </b-field>
                </div>
              </div>


              <div class="field is-horizontal">
                <div class="field-label">
                  <label class="label">Assigned To</label>
                </div>
                <div class="field-body">
                  <b-field>
                    <base-select
                      label
                      :service="userService"
                      fetch-func="all"
                      :fetch-params="{
                        firmId: user.firm.id,
                        filter_by: 'first_name',
                        active: 1,
                        archived:0
                      }"
                      value-key="id"
                      :small="true"
                      @input="val => onInput('assignedTo', val)"
                    >
                      <template #customLabel="{ option }">
                        {{ option.firstName }}
                      </template>
                    </base-select>
                  </b-field>
                 <!--  <b-field v-else>
                      <b-select expanded placeholder="Unassigned" :disabled="true">
                      </b-select>
                  </b-field> -->
                </div>
              </div>



              <!-- <div class="field is-horizontal">
                <div class="field-label">
                  <label class="label">Code 1</label>
                </div>
                <div class="field-body">
                  <b-field>
                      <b-select placeholder="Select Code" v-model="form.code1" size="is-small" expanded>
                        <template v-if="code1List.length">
                          <option :value="code" v-for="(code, key) in code1List">{{ code.name }}</option>
                        </template>
                        <template v-else>
                          <option disabled="true">No Option</option>
                        </template>
                      </b-select>
                  </b-field>
                </div>
              </div> -->

              <template v-for="(dropdown, key) in dropdowns">
                <dropdown :index="key" :dropdown="dropdown" :dropdowns.sync="dropdowns" :selectedCodes.sync="selectedCodes" />
              </template>
              <!-- <div class="field is-horizontal" v-for="(dropdown, key) in dropdowns"> -->
                <!-- <dropdown :key="key" :dropdown="dropdown" /> -->
                <!-- <div class="field-label">
                  <label class="label">Code {{ key+1 }}</label>
                </div>
                <div class="field-body">
                  <b-field>
                      <b-select placeholder="Select Code" size="is-small" v-model="modelCodes['code' + key]" expanded>
                          <option :value="code" v-for="(code, key) in dropdown.list">{{ code.name }}</option>
                      </b-select>
                  </b-field>
                </div> -->
              <!-- </div> -->

              <!-- Work Description Field -->
              <div class="field is-horizontal">
                <div class="field-label">
                  <label class="label">Work Description</label>
                </div>
                <div class="field-body">
                  <b-field>
                    <b-input
                      name="work_description"
                      v-model="form.workDescription"
                      type="textarea"
                    ></b-input>
                  </b-field>
                </div>
              </div>

              <!-- Switch Field -->
              <div class="field is-horizontal">
                <div class="field-label">
                  <label class="label"></label>
                </div>
                <div class="field-body">
                  <div class="columns is-mobile" style="width:100%;">
                    <div class="column is-6">
                      <b-field>
                        <b-switch
                          v-model="form.sendEmailNotification"
                          :true-value="1"
                          :false-value="0"
                          type="is-dark"
                          size="is-small"
                          >Send Email Notification</b-switch
                        >
                      </b-field>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <footer class="card-footer has-background-light">
              <div class="columns">
                <div class="column is-two-fifths"></div>

                <div class="column is-one-fifth">
                  <router-link
                    :to="{ name: 'order-list' }"
                    class="button is-fullwidth is-dark"
                    >CANCEL</router-link
                  >
                  <!-- <button type="button" class="button is-fullwidth is-dark">CANCEL</button> -->
                </div>
                <div class="column is-one-fifth">
                  <b-button
                    class="is-fullwidth"
                    :loading="drafting"
                    @click="draft"
                    v-if="!approved"
                  >SAVE DRAFT</b-button>
                </div>

                <div class="column is-one-fifth">
                  <button class="button is-info is-fullwidth">{{ order ? (approved ? "UPDATE" : "APPROVE") : "SUBMIT" }}</button>
                  <!-- <b-button
                    id="submit_order"
                    class="is-fullwidth"
                    type="is-info"
                    :loading="submitting"
                    @click="submit"
                  >
                    {{ order ? (approved ? "UPDATE" : "APPROVE") : "SUBMIT" }}
                  </b-button> -->
                </div>
              </div>
            </footer>
          </div>

        </form>

  </div>

</template>

<script>

    import moment from "moment";
    import BaseSelect from "@/components/partials/BaseSelect";
    import OrderDetailTabs from "@/components/Order/OrderDetailTabs";
    import { CodeService } from "@/services/code.service";
    import { AssociatedService } from "@/services/associated.service";
    import { FirmService } from "@/services/firm.service";
    import { OrderService } from "@/services/order.service";
    import { UserService } from "@/services/user.service";
    import { PlaceService } from "@/services/place.service";
    import { TagService } from "@/services/tag.service";
    import { AssetService } from "@/services/asset.service";
    import { JsonDenormalizer } from "@/helpers/JsonDenormalizer";
    import VueGoogleAutocomplete from "@/components/partials/VueGoogleAutocomplete";
    import { OrderOperationService } from "@/services/orderOperation.service";
    import Dropdown from "./partials/dropdown";

    export default {
      // Trying to start using the DB for orderTypes and activityTypes
      // orderTypes: ["PLANNED", "REACTIVE"],
      // activityTypes: ["REACTIVE", "PLANNED", "MINOR CAPITAL", "PREVENTIVE"],
      priorities: [
        "HEALTH & SAFETY P1",
        "EMERGENCY P2",
        "EMERGENCY P3",
        "EMERGENCY P4",
        "ROUTINE P5",
        "PROJECTED P6"
      ],
      props: {
        parentOrder: {
          type: Object
        },
        // assets: {
        //   type: Array
        // }
      },
      components: {
        BaseSelect,
        OrderDetailTabs,
        VueGoogleAutocomplete,
        Dropdown,
      },
      data: () => ({
        orderOperationService: OrderOperationService,
        codeService: CodeService,
        firmService: FirmService,
        orderService: OrderService,
        userService: UserService,
        placeService: PlaceService,
        tagService: TagService,
        codesBusy: false, // dependent: orderType -> activityType -> problemCode
        orderTypes: [],
        orderTypeValue: null,
        activityTypes: [],
        problemCodes: [],
        regions: [],
        order: null,
        operation: null,
        form: {
          approver: "",
          orderId: "",
          orderType: "",
          subType: "",
          issuingOrganization: "",
          manager: "",
          contractor: "",
          place: "",
          priority: "",
          address: "",
          problemCode: "",
          workDescription: "",
          reference: "",
          claimPeriod: "",
          assignedTo: null,
          parentWO: "",
          duplicateWO: "",
          onHold: 0,
          furtherWorkRequired: 0,
          returnToSite: 0,
          stormEvent: 0,
          notSurveyed: 0,
          manholeSurcharged: 0,
          address_latitude: 0,
          address_longitude: 0,
          region: "",
          requested_by: "",
          contact_person: "",
          code1: null,
          code2: null,
          code3: null,
          sendEmailNotification: 0
        },
        autocomplete: {
          parentWO: {
            data: [],
            loading: false,
            timeout: null
          },
          duplicateWO: {
            data: [],
            loading: false,
            timeout: null
          }
        },
        serviceLevel: null,
        drafting: false,
        submitting: false,
        activityTypeId:null,
        activityTypeParentId:null,
        activityOwnerId:null,
        assetTypeId:null,
        manager: [],
        assets: [],
        assetId: null,
        code1List: [],
        code1Attribute: null,
        code2List: [],
        code3List: [],
        codefield: [
          {code: null}
        ],
        dropdowns: [],
        selectedCodes: []
        // modelCodes: {
        //   code0: null,
        //   code1: null,
        //   code2: null,
        //   code3: null,
        //   code4: null,
        // }
      }),
      computed: {
        user() {
          return this.$store.state.Auth.user;
        },
        hasSpendLimit() {
          return this.user.spend_limit;
        },
        cardTitle() {
          return this.order ? "UPDATE ORDER" : "CREATE ORDER";
        },
        approved() {
          return this.order && this.order.status === "APPROVED";
        },
        orderIsReactive() {
          const orderType = this.orderTypes.find(type => type.id === this.form.orderType);
          return (orderType && orderType.code.toUpperCase() === 'REACTIVE');
        },
        // This should be for APPROVE (BLAP)
        canApprove(){
          if(!this.order){
            return true;
          }
          else if(this.order && approved){
            return true;
          }
          else if(this.user.permissions.find( perm => perm.name == "can_review_invoices" )){
            return true
          }else {
            return false
          }
        },
        orderCodes() {
          // Need to map code id to its code type
          // so it will be easier to remove specific code
          // e.g.
          // const { activity, ...codes } = orderCodes
          // const ids = Object.values(codes)
          // activity type chained params = { ids, type: 'ACTIVITY' }
          const codes = {};

          if (this.form.orderType) {
            codes['ORDERTYPE'] = this.form.orderType;
          }

          if (this.form.subType) {
            codes['ACTIVITYTYPE'] = this.form.subType;
          }

          if (this.form.problemCode) {
            codes['PROBLEM'] = this.form.problemCode;
          }

          if (this.activityTypeId) {
            codes['ACTIVITY'] = this.activityTypeId;
          }

          if (this.assetTypeId) {
            codes['ASSET'] = this.assetTypeId;
          }
          return codes;
        },
        codingData() {
          let dropdownData = [];
          if (this.dropdowns.length > 0) {
            this.dropdowns.forEach((v, k) => {
              dropdownData.push({
                attribute_id: v.attribute.id,
                child: v.child,
                count: v.count,
                index: v.index,
                parent: v.parent,
                parentCount: v.parentCount,
              });
            });
          }
          let selectedData = [];
          for (var i = 0; i < this.dropdowns.length; i++) {
            selectedData.push(this.selectedCodes[i] ? this.selectedCodes[i].id : null);
          }
          return {dropdownData, selectedData};
        },
      },
      async mounted() {
        /**
         * TODO:
         * Refactor async calls that need to happen on mount
         * into a single promise so that we can know when
         * the UI is ready for us to update all select
         * dropdowns that get populated using AJAX.
         *
         * E.g.
         * this.getRouteData().then(data => {
         *   // ready to set default orderType
         *   // ready to set default contractor
         *   // ready to set issuedBy firm etc.
         * });
         *
         * This will avoid race conditions when a select
         * dropdown's value depends on multiple others.
         * E.g. the contractor firm <select> should
         * only default to first item if only one
         * option is available AND there is no
         * parent order data available etc.
         */
        // Fetch orderType code options on load
        const vm = this;
        this.getAsset();
        this.codeService.all({ type: 'ORDERTYPE' }).then(data => {
        this.form.issuingOrganization = this.user.firm.id;

          // let orderTypes = JsonDenormalizer.denormalize(data);
          // orderTypes = orderTypes.filter(code => {
          //   return (['PLANNED', 'REACTIVE'].indexOf(code.code.toUpperCase()) >= 0)
          //     ? true
          //     : false;
          // });
          // vm.orderTypes = orderTypes;

          // Now that we have orderType codes available:
          if (this.parentOrder) {
            this.form.orderType = "PLANNED";
            this.form.contractor = this.parentOrder.firm.id;
            this.form.address = this.parentOrder.address;
            this.form.parentWO = this.parentOrder.orderId;
          }
        });
        let issuedBy = await this.$refs.issuedBy.fetchOptions();
        if (issuedBy.length == 1) {
          this.form.issuingOrganization = issuedBy[0].id;
        }
        let issuedTo = await this.$refs.issuedTo.fetchOptions();
        if (issuedTo.length == 1 && !this.form.contractor) {
          this.form.contractor = issuedBy[0].id;
        }
      },
      watch: {
        'form.orderType': function(next, from) {
          const vm = this;
          vm.form.problem_code_id = '';
          vm.activityTypes = [];
          vm.form.subType = '';
          if (next) {
            vm.codesBusy = true;
            vm.getActivityTypeCodes(next).then(codes => {
              vm.activityTypes = codes;
              vm.codesBusy = false;
            })
            .catch(err => {
              vm.codesBusy = false;
            })
          }
        },
        'form.subType': function(next, from) {
          const vm = this;

          // Update (3/7/20): subType is not a code string anymore
          // Moved to top. Activity type is not being disabled if subType is set to null (Please select).
          // Need to execute even if subType doesn't have value.
          // For Activity Type Fields
          /* let selectedType = vm.activityTypes.find(code => code.name == vm.form.subType)
          vm.activityTypeParentId = selectedType ? selectedType.id : null; */
          vm.activityTypeParentId = next;
          vm.activityTypeId = null
          vm.assetTypeId = null

          if ( ! next) {
            vm.problemCodes = [];
            vm.form.subType = '';
            vm.form.problemCode = '';
          }
          else {
            vm.codesBusy = true;
            vm.getProblemCodes(next).then(codes => {
              vm.problemCodes = codes;
              vm.codesBusy = false;
            })
            .catch(err => {
              vm.codesBusy = false;
            })

            vm.$nextTick(() => {
              // vm.$refs.activityTypeId.fetchOptions()
              // vm.$refs.assetTypeId.fetchOptions()
            })

          }
        },
        "form.contractor"() {
          this.calculateSla();
          if(this.form.issuingOrganization != this.form.contractor ||  this.form.contractor != this.user.firm.id){
            this.form.assignedTo = null;
          }
        },
        "form.priority"() {
          this.calculateSla();
        },
        "form.region"() {
          this.calculateSla();
        },
        "form.issuingOrganization"(id){

          if(this.form.issuingOrganization != this.form.contractor ||  this.form.contractor != this.user.firm.id){
            this.form.assignedTo = null;
          }
          UserService.all({firmId: this.form.issuingOrganization, filter_by: 'first_name'}).then(response => {
            this.manager = JsonDenormalizer.denormalize(response)
          });
          // this.form.code1 = null;
          this.dropdowns = [];
          this.selectedCodes = [];
          AssociatedService.firmFirmCode({ issued_by: this.form.issuingOrganization, issued_to: this.form.contractor }).then(response => {
            if (response && response[0] && response[0].length) {
              this.dropdowns.push({list: response[0], attribute: response[1], count: 1, parent: 0, child: 0, index:0, parentCount: 0});
            }
          });
          this.getOrderType(id)
        },
        activityTypeId(id){

          if(id == "") this.activityTypeId = null;

          // Why does it only fetches once?
          // if(this.assetTypeId == null){
            this.$nextTick(() => {
              // this.$refs.assetTypeId.fetchOptions()
            });
          // }
        },
        assetTypeId(id){
          if(id == "") this.assetTypeId = null;

          // Why does it only fetches once?
          // if(this.activityTypeId == null){
            this.$nextTick(() => {
              // this.$refs.activityTypeId.fetchOptions()
            });
          // }
        },

        // 'modelCodes.code0'(code) {
        //   this.dropdowns = this.dropdowns.slice(0, 1);
        //   this.getPossibleDropdown(code, 0);
        // },
        // 'modelCodes.code1'(code) {
        //   this.dropdowns = this.dropdowns.slice(0, 2);
        //   this.getPossibleDropdown(code, 1);
        // },
        // 'modelCodes.code2'(code) {
        //   this.dropdowns = this.dropdowns.slice(0, 3);
        //   this.getPossibleDropdown(code, 1);
        // },
        // 'modelCodes.code3'(code) {
        //   this.dropdowns = this.dropdowns.slice(0, 4);
        //   this.getPossibleDropdown(code, 1);
        // },

      },
      methods: {
        async getPossibleDropdown(code, key) {
          // Does the selected code->id match(1) a record in model_has_attributes?
          let exist = await CodeService.getCodeTag({code_id: code.id});
            if (exist.length) {
              // YES Next drop-down driven by: model_has_attributes->attribute_id


              // let attribute = code.attributes.find(element => element.pivot.value == '[SYSTEM][ORDER][CODE_CHAIN]');
              // let attribute_id = attribute ? attribute.id : 0;
              // await CodeService.getDropdownCodes({code_id: code.id, attribute_id: attribute_id}).then(response => {
              //   this.dropdowns.push({list: response[0], attribute: response[1]});
              // });

              exist.forEach((v, k) => {
                let attribute_id = v.pivot.attribute_id ? v.pivot.attribute_id : 0;
                CodeService.getDropdownCodes({code_id: code.id, attribute_id: attribute_id}).then(response => {
                  this.dropdowns.push({list: response[0], attribute: response[1]});
                });
              });

            }else{
              // NO Does the current drop-down attribute->id match a record in model_has_attributes?
              let exist = await CodeService.getCodeTag({attribute_id: this.dropdowns[key].attribute.id});
              if (exist.length) {
                let attribute_id = exist[0].attribute_id;
                await CodeService.getDropdownCodes({code_id: code.id, attribute_id: attribute_id}).then(response => {
                  if (response.length) {
                    this.dropdowns.push({list: response[0], attribute: response[1]});
                  }
                });
              }
            }
        },
        transformedData(status) {

          let data = {
            // coding: JSON.stringify({dropdowns: this.dropdowns, selectedCodes: this.selectedCodes}),
            coding: JSON.stringify(this.codingData),
            orderId: this.form.orderId,
            firm_id: this.form.contractor,
            requested_by: this.form.requested_by,
            contact_person: this.form.contact_person,
            place_id: this.form.place,
            region_tag_id: this.form.region,
            priority: this.form.priority,
            address: this.form.address,
            problem_code_id: this.form.problemCode,
            workDescription: this.form.workDescription,
            supplierOrderId: this.form.reference,
            claimId: this.form.claimPeriod,
            assigned_to: this.form.assignedTo,
            managed_by: this.form.manager,
            parentOrder: this.form.parentWO,
            duplicateOf: this.form.duplicateWO,
            on_hold: this.form.onHold,
            further_work: this.form.furtherWorkRequired,
            return_to_site: this.form.returnToSite,
            big_storm: this.form.stormEvent,
            no_survey: this.form.notSurveyed,
            surcharge_manhole: this.form.manholeSurcharged,
            status,
            // releaseDate and lastUpdated are generated in the API
            // releaseDate: null,
            // lastUpdated: null,
            created_by: this.user.id,
            created_by_firm_id: this.form.issuingOrganization || this.user.firm.id,
            logged_lat: this.form.address_latitude,
            logged_lng: this.form.address_longitude,
            requiredStart: this.form.expectedStart
              ? moment(this.form.expectedStart)
                  .tz(moment.tz.guess())
                  .format()
              : null,
            requiredFinish: this.form.expectedFinish
              ? moment(this.form.expectedFinish)
                  .tz(moment.tz.guess())
                  .format()
              : null,
            send_email_notification: this.form.sendEmailNotification
          };

          // There are parts of the application where orderType and activityType are still being used
          const orderType = this.orderTypes.find(type => type.id === this.form.orderType);
          const activityType = this.activityTypes.find(type => type.id === this.form.subType);;

          data = {
            ...data,
            orderType: orderType ? orderType.code : null,
            activityType: activityType ? activityType.name : null,
            order_type_id: this.form.orderType,
            order_subtype_id: this.form.subType,
          };

          return data;
        },
        create(status) {
          return this.orderService.basicCreate(this.transformedData(status));
        },
        update(status) {
          return this.orderService.update(
            this.order.id,
            this.transformedData(status)
          );
        },
        async getAsset() {
          // await AssetService.all().then(response => {
          //   this.assets = JsonDenormalizer.denormalize(response);
          // });
          await AssetService.getAsset({firm_id: this.user.firm.id}).then(response => {
            // console.log(response);
            this.assets = response;
          });
        },
        createOperation() {
          return this.orderOperationService.create({
            orderId: this.order.id,
            activityCodeId: this.activityTypeId,
            ownerFirmId: this.activityOwnerId,
            locationId: this.assetTypeId,
            operationId: '0010'
          })
          .then(response => JsonDenormalizer.denormalize(response));
        },
        updateOperation() {
          return this.orderOperationService.update(this.operation.id, {
            orderId: this.order.id,
            activityCodeId: this.activityTypeId,
            ownerFirmId: this.activityOwnerId,
            locationId: this.assetTypeId
          })
          .then(response => JsonDenormalizer.denormalize(response));
        },
        async validateCodes() {
          if (Object.keys(this.orderCodes).length) {
            try {
              await this.codeService.chained({ ids: this.getOrderCodeIds() });
            } catch (err) {
              throw err;
            }
          }

          return;

          // Collect codes to be validated
          const codes = [];

          // Get order type id
          const orderTypeCode = this.orderTypes.find(code => {
            return code.code.toUpperCase() == this.form.orderType.toUpperCase();
          });
          const orderTypeId = orderTypeCode ? orderTypeCode.id : null;

          if (orderTypeId) {
            codes.unshift(orderTypeId);
          }

          // Get sub type id
          const activityTypeCode = this.activityTypes.find(code => {
            return code.name.toUpperCase() == this.form.subType.toUpperCase();
          });
          const activityTypeId = activityTypeCode ? activityTypeCode.id : null;

          if (activityTypeId) {
            codes.unshift(activityTypeId);
          }

          // Get problem code id
          // Problem code needs to be validated when order type is REACTIVE
          if (this.form.orderType === "REACTIVE" && this.form.problemCode) {
            codes.unshift(this.form.problemCode);
          }

          // Get operation activity type id
          if (this.activityTypeId) {
            codes.unshift(this.activityTypeId);
          }

          // Get asset code id
          // Asset code needs to be validated when order type is not REACTIVE
          if (this.form.orderType !== "REACTIVE" && this.assetTypeId) {
            codes.unshift(this.assetTypeId);
          }

          try {
            await this.codeService.validateAssociations(codes);
          } catch (err) {
            throw err;
          }
        },
        async draft() {
          this.drafting = true;

          try {
            await this.validateCodes();

            if (this.order) {
              this.order = await this.update("DRAFT").then(response =>
                JsonDenormalizer.denormalize(response.data)
              );
              this.operation = await this.updateOperation();
            } else {
              this.order = await this.create("DRAFT").then(response =>
                JsonDenormalizer.denormalize(response.data)
              );
              // this.operation = await this.createOperation(this.order);
            }

            this.$buefy.toast.open({
              message: "Draft has been saved.",
              type: "is-info",
              position: "is-top-right"
            });
          } catch (err) {}

          this.drafting = false;
        },
        async submit() {
          this.submitting = true;

          try {
            await this.validateCodes();

            const message = `Order has been ${
              this.order ? (this.approved ? "updated" : "approved") : "created"
            }.`;

            if (this.order) {
              this.order = await this.update("APPROVED").then(response =>
                JsonDenormalizer.denormalize(response.data)
              );
              this.operation = await this.updateOperation();
            } else {
              const status =
                this.user.firm.id !== this.form.issuingOrganization
                  ? "PROPOSED"
                  : "APPROVED";

              this.order = await this.create(status).then(response =>
                JsonDenormalizer.denormalize(response.data)
              );
              this.order.assetId = this.assetId;
              // this.operation = await this.createOperation(this.order);
              // Orders Outbound Filter
              localStorage.setItem('__order_table_source', 'outbound');
              // Redirect
              this.$router.push({ name: 'order-list', query: { id: this.order.id }});

            }

            this.$buefy.toast.open({
              message,
              type: "is-info",
              position: "is-top-right"
            });
          } catch (err) {}

          this.submitting = false;
        },

        /* async createOperation(order){

          if(this.activityTypeId && this.assetTypeId){

            const form =  {
                      orderId: this.order.id,
                      activityCodeId: this.activityTypeId,
                      ownerFirmId: this.activityOwnerId,
                      locationId: this.assetTypeId,
                      operationId: '0010',
                    };
            const operation = await this.orderOperationService.create(form);

          }

        }, */
        getActivityTypeCodes(orderType) {
          // Update (3/7/20): orderType is not a code string anymore
          // Currently orderType is a code string so we need to find underlying code manually.
          const vm = this;
          /* const orderTypeCode = this.orderTypes.find(code => {
            return (code.code.toUpperCase() == orderType.toUpperCase());
          });
          const orderTypeId = orderTypeCode
            ? orderTypeCode.id
            : null; */
          return new Promise((resolve, reject) => {
            if ( ! orderType) {
              return resolve([]);
            }
            vm.codeService.chained({ ids: this.getOrderCodeIds("ACTIVITYTYPE"), type: 'ACTIVITYTYPE' })
              .then(data => {
                let codes = JsonDenormalizer.denormalize(data);
                return resolve(codes);
              })
              .catch(err => {
                return reject(err);
              });
          });
        },
        getActivityTypeText(code) {
          const map = {
            'REACTIVE': 'Reactive - Investigation',
            'PREVENTIVE': 'Preventive - Inspection',
            'PLANNED': 'Planned – Maintenance/Repair',
            'MINOR CAPITAL': 'Minor Capital - Upgrade/Renewal	',
          };
          return map[code.name] ? map[code.name] : code.name;
        },
        getProblemCodes(activityType) {
          // Update (3/7/20): activityType is not a code string anymore
          // Currently activityType is a code string so we need to find underlying code manually.
          const vm = this;
          /* const activityTypeCode = this.activityTypes.find(code => {
            return (code.name.toUpperCase() == activityType.toUpperCase());
          });
          const activityTypeId = activityTypeCode
            ? activityTypeCode.id
            : null; */
          return new Promise((resolve, reject) => {
            if ( ! activityType || ! vm.orderIsReactive) {
              return resolve([]);
            }
            vm.codeService.chained({ ids: this.getOrderCodeIds("PROBLEM"), type: 'PROBLEM' })
              .then(data => {
                let codes = JsonDenormalizer.denormalize(data);
                return resolve(codes);
              })
              .catch(err => {
                return reject(err);
              });
          });
        },
        getOrders(search, autocomplete) {
          if (this.autocomplete[autocomplete].timeout) {
            clearTimeout(this.autocomplete[autocomplete].timeout);
          }

          this.autocomplete[autocomplete].timeout = setTimeout(async () => {
            this.autocomplete[autocomplete].loading = true;

            try {
              const response = await this.orderService.all({ search });

              this.autocomplete[autocomplete].data = JsonDenormalizer.denormalize(
                response
              );
            } catch (err) {}

            this.autocomplete[autocomplete].loading = false;
          }, 500);
        },
        onInput(field, val) {
          this.form[field] = val;
        },
        ordersPage() {
          this.$router.replace({ name: "order-list" });
        },
        getAddressData(addressData) {
          let street_number = addressData.street_number ? addressData.street_number : "";
          let route = addressData.route ? addressData.route : "";
          let locality = addressData.locality ? addressData.locality : "";
          let postal_code = addressData.postal_code ? addressData.postal_code : "";
          let administrative = addressData.administrative_area_level_1 ? addressData.administrative_area_level_1 : "";
          let country = addressData.country ? addressData.country : "";

          this.form.address = street_number + " " + route + " " + locality + " " +  postal_code + " " + administrative + " " + country;
          this.form.address_latitude = addressData.latitude;
          this.form.address_longitude = addressData.longitude;
        },
        getGPSLocation() {
          if (navigator.geolocation) {
            // Get Current address position
            navigator.geolocation.getCurrentPosition(
              position => {
                // Format LatLng
                var myLatlng = new google.maps.LatLng(
                  parseFloat(position.coords.latitude),
                  parseFloat(position.coords.longitude)
                );
                // Call method in component
                this.$refs.addressAutoComplete.updateCoordinates(myLatlng);
              },
              error => {
                alert("Error Code: " + err.code + " Error Message: " + err.message);
              },
              {
                timeout: 5000,
                maximumAge: 0,
                enableHighAccuracy: true
              }
            );
            // // Get Current address position
            // navigator.geolocation.getCurrentPosition(location => {
            //   // console.log('asdasdas',location)
            //   // Format LatLng
            //   var myLatlng = new google.maps.LatLng(
            //     parseFloat(location.coords.latitude),
            //     parseFloat(location.coords.longitude)
            //   );
            //   // Call method in component
            //   this.$refs.addressAutoComplete.updateCoordinates(myLatlng);
            // });
          } else {
            alert("Geolocation is not supported by this browser.");
          }
        },
        async calculateSla() {
          if (this.form.contractor && this.form.priority) {
            const data = await this.orderService
              .calculateSla({
                firm_id: this.form.contractor,
                priority: this.form.priority,
                // region_tag_id: this.form.region,
                release_date: moment().format("YYYY-MM-DD HH:mm:ss")
              })
              .then(response => response.data.data);

            this.form.expectedStart = data.result.required_start
              ? new Date(moment(data.result.required_start).format("MM/DD/YYYY HH:mm:ss"))
              : null;
            this.form.expectedFinish = data.result.required_finish
              ? new Date(moment(data.result.required_finish).format("MM/DD/YYYY HH:mm:ss"))
              : null;
            this.serviceLevel = data.service_level;
          }
        },
        getOrderCodeIds(type = "") {
          const { [type]: excluded, ...codes } = this.orderCodes;
          return Object.values(codes);
        },
        async getOrderType(){
          // await FirmService.getHasAtribute({id:this.form.issuingOrganization}).then(response => {
          //   this.orderTypeValue = null;
          //   if (response != null) {
          //     this.orderTypeValue = response.pivot.value;
          //   }
          // });
          // this.getCodeService();
        },
        async getCodeService(){
          let orderType = this.orderTypeValue;
          this.orderTypes = [];
          this.form.orderType = '';
          if (orderType) {
            await this.codeService.all({ type: orderType }).then(data => {
              let orderTypes = JsonDenormalizer.denormalize(data);
              // orderTypes = orderTypes.filter(code => {
              //   return (['PLANNED', 'REACTIVE'].indexOf(code.code.toUpperCase()) >= 0)
              //     ? true
              //     : false;
              // });
              this.orderTypes = orderTypes;
            });
          }
        },
      }
    };

</script>

<style lang="scss" scoped>

    .form {
      .scrollable {
        height: calc(100vh - 104px - 1.5rem - 0.85rem - 1.5rem - 82px);
      }
    }

    .detail {
      .scrollable {
        height: calc(100vh - 104px - 1.5rem - 0.85rem - 1.5rem);
      }
    }

    .overlay {
      width: 100%;
      height: 100%;
      position: absolute;
      top: 0;
      left: 0;
      background: rgba(255, 255, 255, 0.3);
      z-index: 9;
    }

    .field-label .label {
      white-space: normal;
    }

</style>


// WEBPACK FOOTER //
// src/components/pages/Orders/create/basic.vue